import { resolveDiPdfFilename } from 'service/DiIdentity';
import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage,setSelectAll,setSelectAllPendig,updateSelectedRowsPending, updateSelectedRows} from 'reducers/paginationFormDISlice';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Checkbox from '@mui/material/Checkbox';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { createAnnulledPdf } from './annulFormDiPdf';
import BlockIcon from '@mui/icons-material/Block';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DrawIcon from '@mui/icons-material/Draw'; 
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import IconButton from '@mui/material/IconButton'; 
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Paper from '@mui/material/Paper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden';
import VisibilityIcon from '@mui/icons-material/Visibility'; 
import esirIcon from "components/photos/sidebars/esir.svg.png";
import okIcon from "components/photos/sidebars/OK.jpg";
import errorIcon from "components/photos/sidebars/error.jpg"; 
import "css/customDialog.css";
import PropTypes from 'prop-types';
import { ENDPOINT } from 'constants/variables';
import { helpHttp } from 'service/HelpHttp';
import { successErrorAction, warningErrorAction } from 'actions/ErrorActions';

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,
    showShippingButtonFormDI,
    showEmailButtonTickets, 
    showEmailIncidentButtonTickets,
    showESIRButton,
    showESIRPartBButton,
    showESIRDeleteButton,
    showFinishButtonFormDI,
    showEditButtonFormDI,
    showPrintButtonFormDI,
    showDecaHistory,
    showDeleteButtonFormDI,
    showStoreFormDI,
    showUserAccountFormDI,
    selectAll,
    selectAllPendig,
    handleChangSelectAll,
    handleChangSelectAllPending,
    showOriTrasTradename,
    showOriTrasStreet,
    showDestTrasTradename,
    showDestTrasStreet,
    showCodeLERCode,
    showCodeLERDescription,
    typeOfList } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
      {showEditButtonFormDI &&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonFormDI &&
          <TableCell
            key='print'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} >
              {t('Button_Print_PDF')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonFormDI &&
          <TableCell
            key='shipping'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#067330", fontSize: 16}} >
              {t('Button_Copy')}
            </Typography>
          </TableCell>
        } 

        {showShippingButtonFormDI &&
          <TableCell
            key='clone'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#25bbd9", fontSize: 16}} >
              {t('Button_Create_Shipping')}
            </Typography>
          </TableCell>
        } 
        
        {showEmailButtonTickets &&
          <TableCell
            key='email'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Print_EMAIL')}
            </Typography>
          </TableCell>
        }
        {showEmailIncidentButtonTickets &&
          <TableCell
            key='emailinicdent'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#f57c00", fontSize: 16}} >
              {t('Button_Report_Incident')}
            </Typography>
          </TableCell>
        }
        {showDecaHistory && <TableCell
          key='deca'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#f57c00", fontSize: 16, textTransform:"none"}}>
            DeCA
          </Typography>
        </TableCell>}
        {showESIRButton &&
          <TableCell
            key='esir'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16, textTransform:"none"}} >
              {t('Button_SendTo_ESIR')}
            </Typography>
          </TableCell>
        }
        {showESIRPartBButton &&
          <TableCell
            key='esir-part-b'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#df974e", fontSize: 16, textTransform:"none"}} >
              {t('Button_Send_ESIR_PartB')}
            </Typography>
          </TableCell>
        }
        {showESIRDeleteButton &&
          <TableCell
            key='esir-delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#d9534f", fontSize: 16, textTransform:"none"}}>
              Anulación e-SIR
            </Typography>
          </TableCell>
        }
        {showESIRButton &&
          <TableCell
            key='status'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Text_STATUS_ESIR')}
            </Typography>
          </TableCell>
        }
        {showFinishButtonFormDI &&
          <TableCell
            key='pending'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Select').toUpperCase()}
            </Typography>
            <Checkbox checked={typeOfList==="1"?selectAll:selectAllPendig} style={{color:"#4e73df", fontSize: 16}} 
              sx={{
                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
              }}
              onClick={typeOfList==="1"?()=>handleChangSelectAll():()=>handleChangSelectAllPending()}
            />
          </TableCell>
        }
       
        <TableCell
          key='preiddoc_sheet'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='preiddoc_sheet' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'preiddoc_sheet'}
            direction={orderBy === 'preiddoc_sheet' ? order : 'asc'}
            onClick={createSortHandler('preiddoc_sheet')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_PREIDDOC_SHEET')}
                {orderBy ==='preiddoc_sheet'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        <TableCell
          key='sufiddoc_sheet'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='sufiddoc_sheet' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'sufiddoc_sheet'}
            direction={orderBy === 'sufiddoc_sheet' ? order : 'asc'}
            onClick={createSortHandler('sufiddoc_sheet')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_SUFIDDOC_SHEET')}
                {orderBy ==='sufiddoc_sheet'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        <TableCell
          key='number_dt'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='number_dt' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'number_dt'}
            direction={orderBy === 'number_dt' ? order : 'asc'}
            onClick={createSortHandler('number_dt')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_NT_SHEET')}
                {orderBy ==='number_dt'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        <TableCell
          key='date_sheet'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='date_sheet' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'date_sheet'}
            direction={orderBy === 'date_sheet' ? order : 'asc'}
            onClick={createSortHandler('date_sheet')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_DATE')}
                {orderBy ==='date_sheet'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        {showOriTrasTradename  &&
          <TableCell
            key='ori_tras_tradename'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='ori_tras_tradename' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'ori_tras_tradename'}
              direction={orderBy === 'ori_tras_tradename' ? order : 'asc'}
              onClick={createSortHandler('ori_tras_tradename')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_ORI_TRAS')}
                  {orderBy ==='ori_tras_tradename'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        } 
        {showOriTrasStreet  &&
          <TableCell
            key='ori_tras_street'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='ori_tras_street' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'ori_tras_street'}
              direction={orderBy === 'ori_tras_street' ? order : 'asc'}
              onClick={createSortHandler('ori_tras_street')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_Address')}
                  {orderBy ==='ori_tras_street'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        }
        {showDestTrasTradename  &&
          <TableCell
            key='dest_tras_tradename'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='dest_tras_tradename' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'dest_tras_tradename'}
              direction={orderBy === 'dest_tras_tradename' ? order : 'asc'}
              onClick={createSortHandler('dest_tras_tradename')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_DEST_TRAS')}
                  {orderBy ==='dest_tras_tradename'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        }
        {showDestTrasStreet  &&
          <TableCell
            key='dest_tras_street'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='dest_tras_street' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'dest_tras_street'}
              direction={orderBy === 'dest_tras_street' ? order : 'asc'}
              onClick={createSortHandler('dest_tras_street')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_Address')}
                  {orderBy ==='dest_tras_street'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        }
        <TableCell
          key='rel_trans_tradename'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='rel_trans_tradename' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'rel_trans_tradename'}
            direction={orderBy === 'rel_trans_tradename' ? order : 'asc'}
            onClick={createSortHandler('rel_trans_tradename')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_REL_TRANS')}
                {orderBy ==='rel_trans_tradename'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        <TableCell
          key='rel_trans_licenseplate'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='rel_trans_licenseplate' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'rel_trans_licenseplate'}
            direction={orderBy === 'rel_trans_licenseplate' ? order : 'asc'}
            onClick={createSortHandler('rel_trans_licenseplate')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_FORM_LICENSEPLATE')}
                {orderBy ==='rel_trans_licenseplate'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
         {showCodeLERCode  &&
          <TableCell
            key='codeler_code'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='codeler_code' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'codeler_code'}
              direction={orderBy === 'codeler_code' ? order : 'asc'}
              onClick={createSortHandler('codeler_code')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_CODE_LER')}
                  {orderBy ==='codeler_code'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        }
        {showCodeLERDescription  &&
          <TableCell
            key='codeler_namees'
            align='left'
            padding='normal'
            sortDirection={orderBy ==='codeler_namees' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'codeler_namees'}
              direction={orderBy === 'codeler_namees' ? order : 'asc'}
              onClick={createSortHandler('codeler_namees')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                  {t('Text_FORM_CODE_LER_TITLE')}
                  {orderBy ==='codeler_namees'? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </Typography>
              </TableSortLabel> 
          </TableCell>
        } 
        <TableCell
          key='accept'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='accept' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'accept'}
            direction={orderBy === 'accept' ? order : 'asc'}
            onClick={createSortHandler('accept')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_Accept')}
                {orderBy ==='accept'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell> 
        <TableCell
          key='ownformdi_id'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='ownformdi_id' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'ownformdi_id'}
            direction={orderBy === 'ownformdi_id' ? order : 'asc'}
            onClick={createSortHandler('ownformdi_id')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_Code')}
                {orderBy ==='ownformdi_id'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>
        <TableCell
          key='isScanned'
          align='left'
          padding='normal'
          sortDirection={orderBy ==='isScanned' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'isScanned'}
            direction={orderBy === 'isScanned' ? order : 'asc'}
            onClick={createSortHandler('isScanned')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                 {t('Text_IsScanned_DI')}
                {orderBy ==='isScanned'? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel> 
        </TableCell>

        {showDeleteButtonFormDI &&
          <TableCell
            key='delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} > 
              {t('Button_Delete')}
            </Typography>
          </TableCell>
        }
        {showStoreFormDI &&
          <TableCell
            key='tradename'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'tradename'}
              direction={orderBy === 'tradename' ? order : 'asc'}
              onClick={createSortHandler('tradename')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_Store_Create')}
                {orderBy === 'tradename' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        }
        {showUserAccountFormDI &&
          <TableCell
            key='username'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'username'}
              direction={orderBy === 'username' ? order : 'asc'}
              onClick={createSortHandler('username')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_UserAcount_Create')}
                {orderBy === 'username' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        }
        {showShippingButtonFormDI &&
          <TableCell
            key='hasShippings'
            align='center'
            padding='normal'
            sortDirection={order}
          >
              <TableSortLabel
              active={orderBy === 'hasShippings'}
              direction={orderBy === 'hasShippings' ? order : 'asc'}
              onClick={createSortHandler('hasShippings')}
            >
                <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_HAS_SHIPPING')}
                {orderBy === 'hasShippings' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell> 
        }  
        <TableCell
          key='sharedStored'
          align='center'
          padding='normal'
          sortDirection={order}
        >
            <TableSortLabel
            active={orderBy === 'sharedStored'}
            direction={orderBy === 'sharedStored' ? order : 'asc'}
            onClick={createSortHandler('sharedStored')}
          >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
              {t('Text_Share_Form_With')}
              {orderBy === 'sharedStored' ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </Typography>
          </TableSortLabel>
        </TableCell> 
         
       
      
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegFormDI, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegFormDI).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataGeneralSettings']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingFormDI =(props)=>{
  const { 
    dataFormDI,
    setDataFormDI,
    setFormFormDI,
    numTotRegFilter,
    titleTable,
    setOpenDeleteRowFormDI,
    setOpenErrorRowFormDI,
    setOpenSharedRowFormDI, 
    setOpenCopyRowFormDI,
    setOpenShippingRowFormDI,
    setOpenViewShipping,
    setRowEditFormDI, 
    showFinishButtonFormDI,
    showEditButtonFormDI,
    showShippingButtonFormDI,
    showPrintButtonFormDI,
    showDecaHistory,
    showDeleteButtonFormDI,
    showEmailButtonTickets,
    showEmailIncidentButtonTickets,
    showESIRButton,
    showESIRPartBButton,
    showESIRDeleteButton,
    showStoreFormDI,
    showUserAccountFormDI,
    numTotRegFormDI,
    activeOffsetFormDI,
    rangeOffsetFormDI,
    currencyOffsetFormDI,
    setCurrencyOffsetFormDI,
    showOriTrasTradename,
    showOriTrasStreet,
    showDestTrasTradename,
    showDestTrasStreet,
    showCodeLERCode,
    showCodeLERDescription,
    setViewPDF,
    typeOfList
  } = props;
  const {t,i18n} = useTranslation(['listDataForms']);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.loginUser.token);
  const useraccountId = useSelector((state) => state.loginUser.useraccount_id);
  const deleteCodeFormDI = useSelector((state) => state.formatDIUser.delete_code_formdi);
  const { currentPage, order, orderBy,rowsPerPage,selectAll,selectAllPendig,selectedRowsPending,selectedRows} = useSelector((state) => state.paginationFormDI);
  const [countData,setCountData] = useState(dataFormDI.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataFormDI.length) : 0);
  const [annullingId, setAnnullingId] = useState(null);
  const [annulRow, setAnnulRow] = useState(null);
  const [annulCode, setAnnulCode] = useState('000000');
  const openAnnulDialog = (row) => {
    if (Number(row.statussentesir) < 3 || Number(row.statussentesir) === 5 || annullingId !== null) return;
    setAnnulRow(row);
    setAnnulCode('000000');
  };

  const [cancelRow, setCancelRow] = useState(null);
  const [cancelCode, setCancelCode] = useState('000000');
  const [cancellingId, setCancellingId] = useState(null);

  const closeCancelDialog = () => {
    if (cancellingId !== null) return;
    setCancelRow(null);
    setCancelCode('000000');
  };

  const handleCancelFormDI = async (row) => {
    if (!row?.hasDeCA || cancellingId !== null || ['ANULADO', 'Text_FORM_IsAnnulled'].includes(row.accept)) return;
    if (String(cancelCode) !== String(deleteCodeFormDI)) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }

    setCancellingId(row.id);
    try {
      let dto;
      let updateUrl;
      if (row.isScanned) {
        dto = await helpHttp().get2(ENDPOINT, 'form/getformdisignaturebyid/', token, row.id);
        const pdfBlob = await helpHttp().getfilesupload(
          ENDPOINT,
          'pdftos3uploader/downloadfroms3',
          token,
          await resolveDiPdfFilename(ENDPOINT,token,dto.id)
        );
        dto.pdfUrl = await createAnnulledPdf(pdfBlob, dto);
        dto.hasbeenfinishedscanned = true;
        updateUrl = 'form/updateformdisignature';
      } else {
        dto = await helpHttp().get2(ENDPOINT, 'form/getformdibyId/', token, row.id);
        updateUrl = 'form/updateformdi';
      }

      // La base de datos conserva la clave i18n; "ANULADO" es únicamente
      // su representación visible en pantalla y en el libro de registro.
      dto.accept = 'Text_FORM_IsAnnulled';
      dto.isFinished = true;
      dto.useraccount_id = dto.useraccount_id || useraccountId;

      const updateResult = await helpHttp().put(ENDPOINT, updateUrl, token, dto);
      if (updateResult?.status !== 'OK') {
        throw new Error(updateResult?.cause || 'Text_FormDI_Annul_Error');
      }

      if (typeOfList === '1') {
        setDataFormDI((current) => current.filter((item) => item.id !== row.id));
      } else {
        setDataFormDI((current) => current.map((item) => item.id === row.id
          ? {...item, accept: 'Text_FORM_IsAnnulled', isFinished: true,
            hasbeenfinishedscanned: row.isScanned ? true : item.hasbeenfinishedscanned}
          : item));
      }

      dispatch(successErrorAction(t('Text_FormDI_Annul_Success')));
      setCancelRow(null);
      setCancelCode('000000');
    } catch (error) {
      dispatch(warningErrorAction(t(error?.message || 'Text_FormDI_Annul_Error', {
        defaultValue: t('Text_FormDI_Annul_Error'),
      })));
    } finally {
      setCancellingId(null);
    }
  };


  const closeAnnulDialog = () => {
    if (annullingId !== null) return;
    setAnnulRow(null);
    setAnnulCode('000000');
  };

  const handleAnnulInEsir = async (row) => {
    if (Number(row.statussentesir) < 3 || Number(row.statussentesir) === 5 || annullingId !== null) return;
    if (String(annulCode) !== String(deleteCodeFormDI)) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }

    setAnnullingId(row.id);
    try {
      const dto = await helpHttp().get11(ENDPOINT, 'api/esir/getpdfformdibyid', token, row.id);
      dto.useraccount_id = useraccountId;
      const result = await helpHttp().post(ENDPOINT, 'api/esir/annul', token, dto, 120000);
      const success = Array.isArray(result) && result.some((item) => Number(item?.status?.value ?? item?.status) === 200 || item?.status === 'OK');
      if (!success) throw new Error('Text_ESIR_Annul_NotConfirmed');
      setDataFormDI((current) => current.map((item) => item.id === row.id
        ? {...item, statussentesir: 5, hasbeensentesir: true,
          accept: 'Text_FORM_IsAnnulled', isFinished: true}
        : item));
      dispatch(successErrorAction(t('Text_ESIR_Annul_Success')));
      setAnnulRow(null);
      setAnnulCode('000000');
    } catch (error) {
      const backendMessages = Array.isArray(error?.data)
        ? error.data.map((item) => item?.cause || item?.response).filter(Boolean)
        : [error?.data?.cause || error?.data?.response].filter(Boolean);
      const translatedMessages = backendMessages.map((message) => t(message, {defaultValue: message}));
      const fallbackMessage = error?.statusText || error?.message;
      dispatch(warningErrorAction(
        translatedMessages.join(' · ')
          || (fallbackMessage ? t(fallbackMessage, {defaultValue: fallbackMessage}) : t('Text_ESIR_Annul_Error'))
      ));
    } finally {
      setAnnullingId(null);
    }
  };
  
  useEffect(
    () => {
      setCountData(dataFormDI.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataFormDI.length) : 0);  
    },
    [dataFormDI,page,setEmptyRows,rowsPerPage,countData]
  );

  useEffect(() => {
    const updatedRowsPending = dataFormDI.map(item => ({
      ...item,
      isFinished: selectedRowsPending[item.id] || selectAll
    }));
    
    // Evita llamar setDataFormDI si los datos no cambian
    if (JSON.stringify(updatedRowsPending) !== JSON.stringify(dataFormDI))  {
      setDataFormDI(updatedRowsPending);
    }
  }, [dataFormDI, selectedRowsPending,setDataFormDI,selectAll]);
  
      
    // Mantén los otros useEffect que ya tienes
    useEffect(() => {
      const updatedRows = dataFormDI.map((item) => ({
        ...item,
        isPending: selectedRows[item.id] || selectAllPendig,
      }));
    
      // Solo actualiza si hay cambios reales
      if (JSON.stringify(updatedRows) !== JSON.stringify(dataFormDI)) {
        setDataFormDI(updatedRows);
      }
    }, [selectedRows,dataFormDI,setDataFormDI,selectAllPendig]); // Elimina dataPurchaseDelivery de las dependencias
    
  const handleChangeOffset = (event) => {
    setCurrencyOffsetFormDI(event.target.value);
  };

  const handleRequestSort = (event, property) => {
     const isAsc = orderBy === property && order === 'asc';
     dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
     dispatch(setOrderBy(property)); // Actualiza Redux
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };

  const openModalDeleteRowDepartment = (row) => {
    setRowEditFormDI(row);
    setOpenDeleteRowFormDI(true);
  };

  const openModalFormDIPDF = async (row) => {
    setRowEditFormDI(row);
    setViewPDF(true);
  };
 
  const openModalFormDISignaturePDF = async (row) => {
    setRowEditFormDI(row);
    setViewPDF(false);
  };
  
  const handleChangSelectAll = () => { 
    const newSelectAll = !selectAll;
    const updatedSelectedRows = dataFormDI.reduce((acc, item) => {
      acc[item.id] = newSelectAll;
      return acc;
    }, {});

    dispatch(setSelectAll(newSelectAll));
    dispatch(updateSelectedRowsPending(updatedSelectedRows));
    const updatedRows = dataFormDI.map(item => ({
      ...item,
      isFinished: newSelectAll,
    })); 
    setDataFormDI(updatedRows);
    setFormFormDI(formFormDI => ({
    ...formFormDI,
    }));
  };
   
  const handleChangSelectAllPending = () => {
    const newSelectAllPending = !selectAllPendig;
    const updatedSelectedRows = dataFormDI.reduce((acc, item) => {
      acc[item.id] = newSelectAllPending;
      return acc;
    }, {});
    dispatch(setSelectAllPendig(newSelectAllPending));
    dispatch(updateSelectedRows(updatedSelectedRows)); // Un único dispatch con todos los registros
    const updatedRows = dataFormDI.map(item => ({
      ...item,
      isPending: newSelectAllPending,
    }));
    setDataFormDI(updatedRows);
    setFormFormDI(formFormDI => ({
      ...formFormDI,
    }));
  };

  const openViewSharedFormDI = (row) => {
    setRowEditFormDI(row);
    setOpenSharedRowFormDI(true);
  }; 
 
  const openViewCopyFormDI = (row) => {
    if (Number(row?.statussentesir) === 5) return;
    setRowEditFormDI(row);
    setOpenCopyRowFormDI(true);
  }; 

  const openShippingFormDI = (row) => {
    if (Number(row?.statussentesir) === 5) return;
    setRowEditFormDI(row);
    setOpenShippingRowFormDI(true);
  }; 

  const openShippingViewFormDI = (row) => {
    setRowEditFormDI(row);
    setOpenViewShipping(true);
  };  

  const openModalERRORESIR = (row) => {
    setRowEditFormDI(row);
    setOpenErrorRowFormDI(true);
  };
 
  const handleChangeEnabledRow = (row) => {
    const updatedRowsPending = dataFormDI.map(item =>
      item.id === row.id ? { ...item, isFinished: !item.isFinished } : item
    );
    setDataFormDI(updatedRowsPending); 
    dispatch(updateSelectedRowsPending({ 
      id: row.id, 
      isFinished: !row.isFinished 
    }));
    setFormFormDI(formFormDI => ({
      ...formFormDI,
    }));
  };

  const handleChangeEnabledPendingRow = (row) => {
    const updatedRows = dataFormDI.map(item =>
      item.id === row.id ? { ...item, isPending: !item.isPending } : item
    );
    setDataFormDI(updatedRows);
    dispatch(updateSelectedRows({
      id: row.id,
      isPending: !row.isPending,
    }));
    setFormFormDI((formFormDI) => ({
      ...formFormDI,
    }));
  }; 

  const getArrowColor = (row) => {
    if (!row.end_date_sheet) return null;
    const now = new Date();
    const end = new Date(row.end_date_sheet);
    const diffMs = end - now;
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    if (diffDays > 15) return "green";
    if (diffDays > 0) return "orange";
    return "red";
  }; 
   
  const listItems = stableSort(dataFormDI, getComparator(order, orderBy))
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row, keyData) => {
    const arrowColor = getArrowColor(row);
    const isEsirAnnulled = Number(row.statussentesir) === 5;
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonFormDI && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            {row.isScanned ? (
              isEsirAnnulled ? (
                <IconButton size="large" className="edit-icon-button formdi-action-disabled" disabled title="DI anulado en e-SIR">
                  <DrawIcon style={{ fontSize: 28 }} />
                </IconButton>
              ) : (
                <Link to={typeOfList === "1"? `/formdetailsignature/${row.id}`: `/formdetailsignature2/${row.id}`} onClick={() => openModalFormDISignaturePDF(row)} >
                  <IconButton size="large" className="edit-icon-button">
                    <DrawIcon style={{ fontSize: 28 }} />
                  </IconButton>
                </Link>
              )
            ) : (
              isEsirAnnulled ? (
                <IconButton size="large" className="edit-icon-button formdi-action-disabled" disabled title="DI anulado en e-SIR">
                  <EditIcon style={{ fontSize: 28 }} />
                </IconButton>
              ) : (
                <Link to={ typeOfList === "1"? `/formdetail/${row.id}`: `/formdetail2/${row.id}`} onClick={() => openModalFormDISignaturePDF(row)}>
                  <IconButton size="large" className="edit-icon-button">
                    <EditIcon style={{ fontSize: 28 }} />
                  </IconButton>
                </Link>
              )
            )}
          </TableCell>
        )}
        {(showPrintButtonFormDI && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <IconButton size="large" className="print-icon-button" onClick={() => openModalFormDIPDF(row)}>
              <PictureAsPdfIcon style={{ fontSize: 28 }} />
            </IconButton>
          </TableCell>
        )}
        {(showPrintButtonFormDI && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <IconButton
              size="large"
              className={`copy-icon-button ${isEsirAnnulled ? "formdi-action-disabled" : ""}`}
              onClick={() => openViewCopyFormDI(row)}
              disabled={isEsirAnnulled}
              title={isEsirAnnulled ? "DI anulado en e-SIR" : undefined}
            >
              <ContentCopyIcon style={{ fontSize: 28 }} />
            </IconButton>
          </TableCell>
        )}
        {(showShippingButtonFormDI && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <IconButton
              size="large"
              className={`shipping-icon-button ${isEsirAnnulled ? "formdi-action-disabled" : ""}`}
              onClick={() => openShippingFormDI(row)}
              disabled={isEsirAnnulled}
              title={isEsirAnnulled ? "DI anulado en e-SIR" : undefined}
            >
              <LocalShippingIcon style={{ fontSize: 28 }} />
            </IconButton>
          </TableCell>
        )}

       {(showEmailButtonTickets && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <Link to={typeOfList === "1"? `/formdisendemail/${row.id}`: `/formdisendemailended/${row.id}`}>
              <IconButton size="large" className="email-icon-button" >
                <EmailIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Link>
          </TableCell>
        )}
        {(showEmailIncidentButtonTickets && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <Link to={typeOfList === "1"? `/formdisendemailincidentlist/${row.id}`: `/formdisendemailincidentlistended/${row.id}`}>
              <IconButton size="large" className="warning-icon-button" >
                <AttachEmailIcon sx={{ fontSize: 24 }} />
              </IconButton>
            </Link>
          </TableCell>
        )}
        {showDecaHistory && <TableCell align="center">
          <Link
            to={row.hasDeCA
              ? (typeOfList === "1" ? `/formdideca/${row.id}` : `/formdidecaended/${row.id}`)
              : '#'}
            onClick={(event) => { if (!row.hasDeCA) event.preventDefault(); }}
          >
            <IconButton
              size="large"
              className="deca-icon-button"
              disabled={!row.hasDeCA}
              title={row.hasDeCA ? 'Abrir DeCA del DI' : 'Este DI no tiene un DeCA generado'}
            >
              <QrCode2Icon style={{fontSize: 28}} />
            </IconButton>
          </Link>
        </TableCell>}
        {(showESIRButton && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            {!row.hasbeensentesir? (
              <Link to={typeOfList === "1"? `/formdisendesir/${row.id}`: `/formdisendesirended/${row.id}`}>
                <IconButton size="small" className="esir-icon-button">
                  <img src={esirIcon} alt="e-SIR" className="esir-icon-image"/>
                </IconButton>
              </Link>
            ) :
            (
              <IconButton size="small" disableRipple className="esir-icon-button-ok">
                <img src={okIcon} alt="Enviado OK" className="esir-icon-image"/>
              </IconButton>
            )}
          </TableCell>
        )}
        {(showESIRPartBButton && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            {Number(row.statussentesir) === 5 ? (
              <IconButton size="small" disableRipple className="btn-white-disabled" disabled title={t('Text_ESIR_Already_Annulled')}>
                <Badge badgeContent="B" color="warning" overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                  <BlockIcon sx={{fontSize: 28, color: '#d9534f'}} />
                </Badge>
              </IconButton>
            ) : Number(row.statussentesir) === 3 ? (
              <Link to={typeOfList === "1" ? `/formdisendesir/${row.id}` : `/formdisendesirended/${row.id}`}>
                <IconButton size="small" className="esir-icon-button" title={t('Button_Send_ESIR_PartB')}>
                  <Badge badgeContent="B" color="warning" overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <img src={esirIcon} alt={t('Button_Send_ESIR_PartB')} className="esir-icon-image"/>
                  </Badge>
                </IconButton>
              </Link>
            ) : Number(row.statussentesir) >= 4 ? (
              <IconButton size="small" disableRipple className="esir-icon-button-ok" title={t('Text_ESIR_PartB_AlreadySent')}>
                <Badge badgeContent="B" color="warning" overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                  <img src={okIcon} alt={t('Text_ESIR_PartB_AlreadySent')} className="esir-icon-image"/>
                </Badge>
              </IconButton>
            ) : (
              <IconButton size="small" className="btn-white-disabled" disabled title={t('Text_ESIR_PartA_Required')}>
                <Badge badgeContent="B" color="warning" overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                  <img src={esirIcon} alt={t('Button_Send_ESIR_PartB')} className="esir-icon-image"/>
                </Badge>
              </IconButton>
            )}
          </TableCell>
        )}
        {(showESIRDeleteButton && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            <IconButton
              size="large"
              onClick={() => openAnnulDialog(row)}
              disabled={Number(row.statussentesir) < 3 || Number(row.statussentesir) === 5 || annullingId !== null}
              title={Number(row.statussentesir) === 5
                ? t('Text_ESIR_Already_Annulled')
                : Number(row.statussentesir) < 3
                  ? t('Text_ESIR_Annul_Requires_Sent')
                  : t('Button_Annul_ESIR')}
              sx={{
                color: Number(row.statussentesir) === 5 ? '#9e9e9e' : '#d9534f',
                backgroundColor: '#fff',
                boxShadow: '0 5px 14px rgba(217,83,79,.22)',
                '&:hover': { backgroundColor: '#fff2f1' }
              }}
            >
              {annullingId === row.id
                ? <CircularProgress size={24} color="inherit" />
                : <BlockIcon sx={{fontSize: 28}} />}
            </IconButton>
          </TableCell>
        )}
        {(showESIRButton && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            {row.statussentesir===null || row.statussentesir==="" || row.statussentesir==="0" || row.statussentesir===0? (
              <IconButton size="small" className="btn-white-disabled" disabled>
                  <img src={esirIcon} alt="e-SIR" className="esir-icon-image"/>
                </IconButton>
            ) : 
            (row.statussentesir===2 ) ?
              <IconButton
                size="small"
                className="btn-white-error"
                onClick={() => openModalERRORESIR(row)}
                aria-label="Error e-SIR"
              >
                <img src={errorIcon} alt="Error e-SIR" className="btn-img" />
              </IconButton>:
            (Number(row.statussentesir) === 5) ? (
              <IconButton size="small" disableRipple className="btn-white-disabled" title={t('Text_ESIR_Already_Annulled')}>
                <BlockIcon sx={{fontSize: 28, color: '#d9534f'}} />
              </IconButton>
            ) : (Number(row.statussentesir) >= 3) ? (
              <IconButton size="small" disableRipple className="esir-icon-button-ok">
                <img src={okIcon} alt="Enviado OK" className="esir-icon-image"/>
              </IconButton>
            ) : null}
          </TableCell>
        )}

        {(showFinishButtonFormDI && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Checkbox checked={typeOfList==="1"?row.isFinished:row.isPending} style={{color:"#4e73df", fontSize: 16}}  
            sx={{
              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
            }}
            onClick={typeOfList==="1"?()=>handleChangeEnabledRow(row):()=>handleChangeEnabledPendingRow(row)}
          />
          </TableCell>
        }
        
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.preiddoc_sheet}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.sufiddoc_sheet}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.number_dt}
          </Typography>
        </TableCell>
        <TableCell
          align="right"
          className={
            row.widevalidity === true && arrowColor
              ? `validity-cell validity-${arrowColor}`
              : ""
          }
        >
          <Typography style={{color:"#000000", fontSize: 16}} >
          {row.widevalidity!==null && row.widevalidity!=="" && row.widevalidity===true?
            (row.date_sheet!==null && row.date_sheet!==""?new Date(row.date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):"")+
              (row.end_date_sheet!==null && row.end_date_sheet!==""?" "+new Date(row.end_date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):"")
              :row.date_sheet!==null && row.date_sheet!==""?new Date(row.date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}

           </Typography>
        </TableCell>
        {showOriTrasTradename  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.ori_tras_tradename}
            </Typography>
          </TableCell>
        }
        {showOriTrasStreet  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.ori_tras_street}
            </Typography>
          </TableCell>
        }
        {showDestTrasTradename  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.dest_tras_tradename}
            </Typography>
          </TableCell>
        } 
        {showDestTrasStreet  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.dest_tras_street}
            </Typography>
          </TableCell>
        }  
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.rel_trans_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {t(row.rel_trans_licenseplate)}
          </Typography>
        </TableCell> 
        {showCodeLERCode  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.codeler_code}
            </Typography>
          </TableCell>
        }  
        {showCodeLERDescription  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.codeler_namees}
            </Typography>
          </TableCell>
        }  
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {t(row.accept)}
          </Typography>
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.ownformdi_id}
          </Typography>  
        </TableCell>
        <TableCell align="center">
          <Checkbox checked={row.isScanned} disabled/>
        </TableCell>
        {(showDeleteButtonFormDI && row.id !== "" && row.id !== null) && (
          <TableCell align="center">
            {row.hasDeCA ? (
              <IconButton
                size="large"
                className="delete-icon-button"
                disabled={row.accept === 'ANULADO' || row.accept === 'Text_FORM_IsAnnulled' || cancellingId !== null}
                title={row.accept === 'ANULADO' || row.accept === 'Text_FORM_IsAnnulled'
                  ? t('Text_FormDI_Already_Annulled') : t('Button_Annul')}
                onClick={() => { setCancelRow(row); setCancelCode('000000'); }}
              >
                {cancellingId === row.id
                  ? <CircularProgress size={24} color="inherit" />
                  : <HighlightOffIcon style={{ fontSize: 30 }} />}
              </IconButton>
            ) : (
              <IconButton
                size="large"
                className="delete-icon-button"
                title={t('Button_Delete')}
                onClick={() => openModalDeleteRowDepartment(row)}
              >
                <DeleteIcon style={{ fontSize: 28 }} />
              </IconButton>
            )}
          </TableCell>
        )}
        {showStoreFormDI  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.tradename}
            </Typography>  
          </TableCell>
        }
        {showUserAccountFormDI  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.username}
            </Typography>  
          </TableCell>
        }
        {showShippingButtonFormDI &&
          <TableCell align="center">
            {row.hasShippings===1 ? (
              <IconButton size="large" className="shared-view-icon-button" onClick={() => openShippingViewFormDI(row)}>
                <VisibilityIcon style={{ fontSize: 28 }} />
              </IconButton>
            ) : (
              <IconButton size="large" disableRipple className="shared-view-icon-button-disabled">
                <VisibilityIcon style={{ fontSize: 28 }} />
              </IconButton>
            )}
          </TableCell>
        }
        <TableCell align="center">
          {row.hasbeenshared ? (
            <IconButton size="large" className="shared-view-icon-button" onClick={() => openViewSharedFormDI(row)}>
              <VisibilityIcon style={{ fontSize: 28 }} />
            </IconButton>
          ) : (
            <IconButton size="large" disableRipple className="shared-view-icon-button-disabled">
              <VisibilityIcon style={{ fontSize: 28 }} />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegFormDI={numTotRegFormDI} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" sx={{ maxHeight: 1400 }}>
            <Table sx={{ minWidth: '800px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t} showShippingButtonFormDI={showShippingButtonFormDI} showEmailButtonTickets={showEmailButtonTickets}  showEmailIncidentButtonTickets={showEmailIncidentButtonTickets} showESIRButton={showESIRButton} showESIRPartBButton={showESIRPartBButton} showESIRDeleteButton={showESIRDeleteButton} showFinishButtonFormDI={showFinishButtonFormDI} showEditButtonFormDI={showEditButtonFormDI} showPrintButtonFormDI={showPrintButtonFormDI} showDecaHistory={showDecaHistory} showDeleteButtonFormDI={showDeleteButtonFormDI} showStoreFormDI={showStoreFormDI} showUserAccountFormDI={showUserAccountFormDI} selectAll={selectAll} selectAllPendig={selectAllPendig} handleChangSelectAll={handleChangSelectAll} handleChangSelectAllPending={handleChangSelectAllPending} showOriTrasTradename={showOriTrasTradename} showOriTrasStreet={showOriTrasStreet} showDestTrasTradename={showDestTrasTradename} showDestTrasStreet={showDestTrasStreet} showCodeLERCode={showCodeLERCode} showCodeLERDescription={showCodeLERDescription} typeOfList={typeOfList}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={20} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  {activeOffsetFormDI && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetFormDI"
                            name="currencyOffsetFormDI"
                            value={currencyOffsetFormDI}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetFormDI
                            }}>
                            {rangeOffsetFormDI.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={21}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                  <TableCell colSpan={10}>
                  </TableCell>
                </TableRow>
              </TableFooter> 
            </Table>
          </TableContainer>
      </Box>
      <Dialog open={Boolean(cancelRow)} onClose={closeCancelDialog} PaperProps={{className:'my-dialog-paper-danger'}}>
        <DialogTitle className="my-dialog-title-danger">
          {t('Text_FormDI_Annul_Title')} {cancelRow?.ownformdi_id} - {cancelRow?.preiddoc_sheet}{cancelRow?.sufiddoc_sheet}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="my-dialog-contentText-danger">
            {t('Text_FormDI_Annul_Description')}<br />{t('Text_FormDI_Annul_CodeHelp')}
          </DialogContentText>
          <TextField autoFocus margin="dense" label={t('Text_FormDI_Annul_Code')} type="text" fullWidth
            variant="standard" className="my-dialog-input-danger" value={cancelCode}
            onChange={(event) => setCancelCode(event.target.value)}
            onKeyDown={(event) => { if (event.key === 'Enter' && cancelRow) handleCancelFormDI(cancelRow); }} />
        </DialogContent>
        <DialogActions className="my-dialog-actions">
          <Button onClick={closeCancelDialog} className="my-dialog-button-cancel-danger" disabled={cancellingId !== null}>
            {t('Button_Cancel')}
          </Button>
          <Button variant="contained" onClick={() => cancelRow && handleCancelFormDI(cancelRow)}
            className="my-dialog-button-delete" disabled={cancellingId !== null}>
            {cancellingId !== null ? <CircularProgress size={22} color="inherit" /> : t('Button_Annul')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(annulRow)}
        onClose={closeAnnulDialog}
        PaperProps={{ className: 'my-dialog-paper-danger' }}
      >
        <DialogTitle className="my-dialog-title-danger">
          {t('Text_ESIR_Annul_Title', {
            id: annulRow?.id,
            document: `${annulRow?.preiddoc_sheet || ''}${annulRow?.sufiddoc_sheet || ''}`
          })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="my-dialog-contentText-danger">
            {t('Text_ESIR_Annul_Description')}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="annulEsirCode"
            label={t('Text_Label')}
            type="text"
            fullWidth
            variant="standard"
            className="my-dialog-input-danger"
            value={annulCode}
            onChange={(event) => setAnnulCode(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && annulRow) handleAnnulInEsir(annulRow);
            }}
          />
        </DialogContent>
        <DialogActions className="my-dialog-actions">
          <Button onClick={closeAnnulDialog} className="my-dialog-button-cancel-danger" disabled={annullingId !== null}>
            {t('Button_Cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={() => annulRow && handleAnnulInEsir(annulRow)}
            className="my-dialog-button-delete"
            disabled={annullingId !== null}
          >
            {annullingId !== null ? <CircularProgress size={22} color="inherit" /> : t('Button_Annul_ESIR')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

TableSortingFormDI.propTypes = {
  dataFormDI: PropTypes.array.isRequired,
  setFormFormDI: PropTypes.func.isRequired,
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,
  setOpenDeleteRowFormDI: PropTypes.func.isRequired, 
  setOpenErrorRowFormDI: PropTypes.func.isRequired,  
  setOpenSharedRowFormDI: PropTypes.func.isRequired, 
  setOpenCopyRowFormDI: PropTypes.func.isRequired, 
  setOpenShippingRowFormDI: PropTypes.func.isRequired, 
  setOpenViewShipping: PropTypes.func.isRequired,  
  setRowEditFormDI: PropTypes.func.isRequired,    
  showFinishButtonFormDI: PropTypes.bool.isRequired,  
  showEditButtonFormDI: PropTypes.bool.isRequired,  
  showShippingButtonFormDI: PropTypes.bool.isRequired,  
  showPrintButtonFormDI: PropTypes.bool.isRequired,  
  showDeleteButtonFormDI: PropTypes.bool.isRequired,
  showEmailButtonTickets: PropTypes.bool.isRequired,
  showEmailIncidentButtonTickets: PropTypes.bool.isRequired,
  showESIRButton: PropTypes.bool.isRequired,
  showESIRPartBButton: PropTypes.bool.isRequired,
  showESIRDeleteButton: PropTypes.bool.isRequired,
  showStoreFormDI: PropTypes.bool.isRequired,
  showUserAccountFormDI: PropTypes.bool.isRequired, 
  activeOffsetFormDI: PropTypes.bool.isRequired,
  rangeOffsetFormDI: PropTypes.array.isRequired,
  currencyOffsetFormDI: PropTypes.number.isRequired,
  setCurrencyOffsetFormDI: PropTypes.func.isRequired,
  showOriTrasTradename: PropTypes.bool.isRequired,
  showOriTrasStreet: PropTypes.bool.isRequired,
  showDestTrasTradename: PropTypes.bool.isRequired,
  showDestTrasStreet: PropTypes.bool.isRequired,
  showCodeLERCode: PropTypes.bool.isRequired,
  showCodeLERDescription: PropTypes.bool.isRequired,
  setViewPDF: PropTypes.func.isRequired,
  typeOfList: PropTypes.string.isRequired 
};
  
export default TableSortingFormDI;
